import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Select, Spin, message } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { get, map } from 'lodash';
import { userMangement } from '../../redux/actions/authActions';
import {
  MARKETING_USER_ADDED_SUCCESS,
  MARKETING_USER_UPDATE_SUCCESS,
} from '../../constants/messages';

const { Option } = Select;

function AddMarektingUser(props) {
  const { refreshUserList, showModal, onClose, edit, initialValue } = props;
  const [loading, setLoading] = useState(false);
  const [showBrandSelector, setShowBrandSelector] = useState(false);
  const [roles, setRoles] = useState([]);
  const [brands, setBrands] = useState([]);

  const dispatch = useDispatch();

  const addMarketingUser = (values) => {
    setLoading(true);
    dispatch(
      userMangement('create.marketing_user', {
        ...values,
        is_active: true,
      })
    )
      .then(() => {
        message.success(MARKETING_USER_ADDED_SUCCESS);
        refreshUserList();
        onClose();
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const updateMarketingUser = (values) => {
    setLoading(true);
    dispatch(
      userMangement('update.marketing_user', {
        ...values,
        is_active: true,
        id: get(initialValue, 'id'),
      })
    )
      .then(() => {
        message.success(MARKETING_USER_UPDATE_SUCCESS);
        refreshUserList();
        onClose();
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const onFinish = (values) => {
    if (edit) {
      updateMarketingUser(values);
    } else {
      addMarketingUser(values);
    }
  };

  const fetchBrands = () => {
    setLoading(true);
    dispatch(userMangement('list.brands'))
      .then((result) => {
        setLoading(false);
        setBrands(get(result, 'data'));
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const fetchRoles = () => {
    setLoading(true);
    dispatch(userMangement('list.roles'))
      .then((result) => {
        setLoading(false);
        setRoles(get(result, 'data'));
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (showModal) {
      fetchRoles();
      fetchBrands();
    }
  }, [showModal]);

  const getInitialValues = () => {
    return {
      name: get(initialValue, 'name'),
      email: get(initialValue, 'email'),
      role_id: get(initialValue, 'Role.id'),
      company_id: map(get(initialValue, 'UserCompanies'), (company) =>
        get(company, 'Company.id')
      ),
    };
  };

  return (
    <>
      <Spin spinning={loading}>
        <div className="heading">
          <LeftOutlined
            className="back-btn"
            onClick={() => {
              onClose();
            }}
          />
          {edit ? 'Update' : 'Add'} Marketing User
        </div>

        <div className="add-user-container">
          <Form
            name="basic"
            layout="vertical"
            initialValues={edit ? getInitialValues() : {}}
            onFinish={onFinish}
            autoComplete="off"
            requiredMark={false}
          >
            <div className="mt-20">
              <p className="subheading">
                Enter the following details of the person to whom you want to
                share the access
              </p>
            </div>
            <div className="mt-40 form-row">
              <div className="input-container">
                <Form.Item
                  label="Enter Full Name"
                  name="name"
                  className="form-item"
                  rules={[
                    {
                      required: true,
                      message: 'Please input full name!',
                    },
                  ]}
                >
                  <Input size="large" placeholder="Enter full name" />
                </Form.Item>
              </div>

              <div className="input-container">
                <Form.Item
                  label="Email id "
                  name="email"
                  className="form-item"
                  rules={[
                    {
                      required: true,
                      message: 'Please input your registered email!',
                    },
                    {
                      type: 'email',
                      message: 'Please Input valid email',
                    },
                  ]}
                >
                  <Input size="large" placeholder="Enter Email or mobile no." />
                </Form.Item>
              </div>
            </div>
            <div className="mt-20 form-row">
              <div className="input-container">
                <Form.Item
                  label="Select User Type"
                  name="role_id"
                  className="form-item"
                  rules={[
                    {
                      required: true,
                      message: 'Please select user type!',
                    },
                  ]}
                >
                  <Select
                    placeholder="Select user type"
                    size="large"
                    onChange={(value, obj) => {
                      setShowBrandSelector(
                        get(obj, 'children') === 'Marketing Manager'
                      );
                    }}
                  >
                    {map(roles, (role) => (
                      <Option key={get(role, 'id')} value={get(role, 'id')}>
                        {get(role, 'name')}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
              <div className="input-container">
                {showBrandSelector && (
                  <Form.Item
                    label="Allocated Brands"
                    name="company_id"
                    className="form-item"
                    rules={[
                      {
                        required: true,
                        message: 'Please select brand!',
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select Brands"
                      size="large"
                      mode="multiple"
                    >
                      {map(brands, (brand) => (
                        <Option key={get(brand, 'id')} value={get(brand, 'id')}>
                          {get(brand, 'name')}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}
              </div>
            </div>

            <div className="btn-container mt-40">
              <div className="mt-20">
                <Button block type="primary" htmlType="submit">
                  Continue
                </Button>
              </div>
              <div className="mt-20 ">
                <Button className="default-btn" onClick={onClose} block>
                  Go Back
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </Spin>
    </>
  );
}

export default AddMarektingUser;
